// Skeleton (job page round 2, Amir 26 Oct: "while loading, use a proper skeleton"): what a page will be,
// drawn before it has its words. Faint bars at the sizes the real lines will have (a title, a line, a
// small line, a row's height, a thumbnail), on the page's own grid, so nothing moves when the words
// arrive. No placeholder words, and nothing moves while it waits (no shimmer). A SkeletonGroup holds
// them and is what a screen reader hears: one status line, "Loading job 24612". Reads only --skel-*.
import type { ReactNode } from 'react';
import './Skeleton.css';

export type SkeletonShape = 'title' | 'name' | 'line' | 'small' | 'row' | 'thumb' | 'button';
export type SkeletonWidth = 'short' | 'mid' | 'long' | 'full';

export interface SkeletonProps {
  shape?: SkeletonShape;
  /** How much of its line it takes; a thumb and a button keep their own size. */
  width?: SkeletonWidth;
}

/** One bar, hidden from screen readers (its group speaks for it). */
export function Skeleton({ shape = 'line', width = 'long' }: SkeletonProps) {
  return <span className="fl-skel" data-shape={shape} data-width={width} aria-hidden="true" />;
}

export interface SkeletonGroupProps {
  /** What's loading, said once to screen readers ("Loading job 24612"). */
  label: string;
  children: ReactNode;
  /** Bars side by side (a row of thumbnails, a line of buttons); a stack by default. */
  direction?: 'stack' | 'row';
}

export function SkeletonGroup({ label, children, direction = 'stack' }: SkeletonGroupProps) {
  return (
    // a span, so it can stand in a heading's place (the title while the job loads)
    <span className="fl-skel-group" data-direction={direction}>
      <span className="fl-skel-group__say" role="status">
        {label}
      </span>
      {children}
    </span>
  );
}

/** Bars side by side inside a group, saying nothing of their own. */
export function SkeletonRow({ children }: { children: ReactNode }) {
  return (
    <span className="fl-skel-group" data-direction="row" aria-hidden="true">
      {children}
    </span>
  );
}
